import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { TFieldRendererProps } from '@/types/TSmartCRM';
import { EFieldMode } from 'src/enums/ESmartCRM';

export const DateRenderer = ({
	value,
	onChange,
	mode,
	size,
	disabled = false,
	placeholder,
}: TFieldRendererProps) => {
	const dateValue = value ? dayjs(value as string) : null;

	if (mode === EFieldMode.DISPLAY) {
		return <span>{dateValue ? dateValue.format('DD/MM/YYYY') : '-'}</span>;
	}

	return (
		<DatePicker
			value={dateValue}
			onChange={(date) => onChange?.(date ? date.format('DD/MM/YYYY') : null)}
			size={size}
			disabled={disabled}
			placeholder={placeholder}
			format="DD/MM/YYYY"
		/>
	);
};
